<template>
  <div class="v-cal">
    <header class="v-cal-header">
      <div class="v-cal-header__actions">
        <div class="actions-left">
          <button
            class="v-cal-button"
            v-if="showTodayButton"
            @click="goToToday"
            :class="{
              'v-cal-button--is-active':
                activeDate && activeDate.isSame(today, 'day')
            }"
          >
            {{ labels.today }}
          </button>
          <button
            :disabled="!isPrevAllowed"
            class="v-cal-button"
            @click="prev"
            v-html="labels.back"
          ></button>
          <button
            :disabled="!isNextAllowed"
            class="v-cal-button"
            @click="next"
            v-html="labels.next"
          ></button>
        </div>
        <div class="actions-right">
          <button
            class="v-cal-button"
            :key="view"
            v-for="view in availableViews"
            @click="switchView(view)"
            :class="{ 'v-cal-button--is-active': activeView === view }"
          >
            {{ labels[view] | capitalizeFirstLetter }}
          </button>
        </div>
      </div>
      <div class="v-cal-header__title-bar">
        <h3 class="v-cal-header__title">{{ calendarTitle }}</h3>
      </div>
    </header>
    <component
      :is="activeView"
      :class="'v-cal-content--' + activeView"
      v-bind="activeViewProps"
    ></component>
    <footer class="v-cal-footer">
      <button

          @click="saveCall" class="v-cal-button is-rounded is-primary"
          :class="{
            'btn-alert':replaceClientsArr
          }"
          v-tooltip.top="{
            content:getRepClientsData()
          }"
          v-if="newCall">
        Save <span v-if="replaceClientsArr">And Replace Clients Scheduled Calls</span>
      </button>
    </footer>
  </div>
</template>

<script>
import Event from "../model/Event";

import config from "../utils/config";
import { defaultLabels, defaultViews } from "../utils/config";

import { EventBus } from "./EventBus";

import moment from "moment";
import Month from "./views/Month";
import Week from "./views/Week";
import Day from "./views/Day";

import EventDialog from "./dialog";
import {mapState} from "vuex";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "VueScheduler",
  components: { Month, Week, Day },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    shift: {
      type: Array,
      default: () => []
    },
    showTodayButton: {
      type: Boolean,
      default: () => config.showTodayButton
    },
    minDate: {
      type: [Date, Object],
      default: () => config.minDate
    },
    maxDate: {
      type: [Date, Object],
      default: () => config.maxDate
    },
    labels: {
      type: Object,
      default: () => config.labels,
      validator(value) {
        for (const labelKey in defaultLabels) {
          if (!value.hasOwnProperty(labelKey)) {
            return false;
          }
        }
        return true;
      }
    },
    timeRange: {
      type: Array,
      default: () => config.timeRange,
      validator(value) {
        if (
          value.length !== 2 ||
          value[0] > value[1] ||
          value[0] < 0 ||
          value[1] > 23
        ) {
          return false;
        }
        return true;
      }
    },
    availableViews: {
      type: Array,
      default: () => config.availableViews,
      validator(value) {
        const possible = defaultViews;
        let error = false;
        value.forEach(view => {
          if (possible.indexOf(view) === -1) {
            error = true;
          }
        });
        return !error;
      }
    },
    initialDate: {
      type: [Date, Object],
      default: () => config.initialDate
    },
    initialView: {
      type: String,
      default: () => config.initialView
    },
    use12: {
      type: Boolean,
      default: () => config.use12
    },
    showTimeMarker: {
      type: Boolean,
      default: () => config.showTimeMarker
    },
    eventDisplay: {
      type: [String, Function],
      default: () => config.eventDisplay
    },
    disableDialog: {
      type: Boolean,
      default: false
    },
    eventDialogConfig: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mode: {
      type: String
    },
  },
  data() {
    return {
      today: moment(),
      activeView: "",
      activeDate: null,
      newCall: null,
      replaceClientsArr:null,
    };
  },
  mounted() {

    //  Initial setup
    this.activeView = this.initialView;
    this.activeDate = moment(this.initialDate);


    //  Bind events
    this.bindEvents();
    // $(".dropdown-toggle-split").on("click", function() {
    // v-cal-content v-cal-content--day
    //   $(".v-cal").animate({ scrollTop: 9999 }, "fast");
    // // });
  },
  beforeDestroy() {
    EventBus.$off("day-clicked");
    EventBus.$off("time-clicked");
    EventBus.$off("event-clicked");
    EventBus.$off("event-canceled");
    EventBus.$off("save-call");
    EventBus.$off("setScrollLoading");
  },
  methods: {
    openEventDialog(data) {
      let replaceClients =  data.replaceClients.length > 0 ? data.replaceClients :null;
      this.replaceClientsArr = replaceClients;
      if (!this.disableDialog) {
        const { fields, ...config } = this.eventDialogConfig;

        if (data instanceof Date) {
          config.date = data;
        } else {
          let startTimeMinutes = 0;
          switch (data.quarter) {
            case 1:
              startTimeMinutes = 0;
              break;
            case 2:
              startTimeMinutes = 15;
              break;
            case 3:
              startTimeMinutes = 30;
              break;
            case 4:
              startTimeMinutes = 45;
              break;
          }

          config.date = data.date;
          config.startTime =
            data.time !== null ? moment(data.time, "HH") : null;
          config.startTime.set("minute", startTimeMinutes);
          config.endTime =
            data.time !== null ? moment(data.time, "HH").add(1, "h") : null;
          // config.endTime.set('minute', endTimeMinutes);
        }

        EventDialog.show(
            config,
            fields,
            this.dictionaries.activity.scheduled_calls_statuses ? this.dictionaries.activity.scheduled_calls_statuses : null,
            this.openCaComponent.clientObj,this.dictionaries.general.client_questions ? this.dictionaries.general.client_questions:null,
            this.initialDate?this.initialDate:null,
        ).$on("event-created", async (event, reason, comment) => {

          if(replaceClients){
            await apiClientCreator(`client/schedule_call/client_new_date`)
                .get("", { params: {clients:replaceClients} })
                .then(res => {
                  res.data.map(async item => {
                   let index = this.events.findIndex(x => x.clientId ===item.client_id);
                    this.events[index].startTime = moment(item.date).format("HH:mm:s");
                    this.events[index].endTime = moment(item.date).add(15, "minutes")
                        .format("HH:mm:s")
                  });
                });
          }


          this.events.push(event._e);
          this.newCall = this.events[this.events.length - 1];
          this.$emit("event-created", event._e, reason, comment,replaceClients);
        });

        // EventDialog.show({
        //     title: 'Custom dialog',
        //     createButtonLabel: 'Save'
        // }, [
        //     // {
        //     //     name: 'text_field',
        //     //     label: 'Text field'
        //     // },
        //     // {
        //     //     name: 'email',
        //     //     type: 'email'
        //     // },
        //     // {
        //     //     name: 'password',
        //     //     type: 'password'
        //     // },
        //     // {
        //     //     name: 'is_checked',
        //     //     type: 'checkbox'    //  Unsupported for now
        //     // },
        //     // {
        //     //     name: 'check_choices[]',
        //     //     type: 'checkbox',           //  Unsupported for now
        //     //     choices: [
        //     //         { label: 'Choice 1', value: 'choice1' },
        //     //         { label: 'Choice 2', value: 'choice2' }
        //     //     ]
        //     // },
        //     // {
        //     //     name: 'radio_choices',
        //     //     type: 'radio',                //  Unsupported for now
        //     //     choices: [
        //     //         { label: 'Radio 1', value: 'rad1' },
        //     //         { label: 'Radio 2', value: 'rad2' }
        //     //     ]
        //     // },
        //     // {
        //     //     name: 'textarea',
        //     //     type: 'textarea'
        //     // }
        //     {
        //         name: 'single-select',
        //         type: 'select',                                              //  Unsupported for now
        //         choices: [
        //             { value: 'single1', label: 'Single list 1' },
        //             { value: 'single2', label: 'Single list 2' },
        //             { value: 'single3', label: 'Single list 3' },
        //             { value: 'single4', label: 'Single list 4' },
        //             { value: 'single5', label: 'Single list 5' }
        //         ]
        //     },
        //     {
        //         name: 'multiple-select',
        //         type: 'select',                                                  //  Unsupported for now
        //         choices: [
        //             { value: 'multiple1', label: 'Multiple list 1' },
        //             { value: 'multiple2', label: 'Multiple list 2' },
        //             { value: 'multiple3', label: 'Multiple list 3' },
        //             { value: 'multiple4', label: 'Multiple list 4' },
        //             { value: 'multiple5', label: 'Multiple list 5' }
        //         ],
        //         multiple: true
        //     }
        // ]);
      }
    },
    bindEvents() {
      EventBus.$on("setScrollLoading", date => {
        this.$emit("setScrollLoading", date);
      });
      EventBus.$on("day-clicked", date => {
        this.$emit("day-clicked", date);
        this.openEventDialog(date);
      });
      EventBus.$on("time-clicked", data => {
        this.$emit("time-clicked", data);
        if(this.openCaComponent.clientId !== null){
          this.openEventDialog(data);
        }

      });
      EventBus.$on("event-clicked", event => {
        this.$emit("event-clicked", event._e);
      });
      EventBus.$on("event-canceled", event => {
        this.$emit("event-canceled", event._e);
      });
      EventBus.$on("save-call", event => {
        this.$emit("save-call", event._e);
      });
    },
    goToToday() {
      this.activeDate = moment(this.today);
    },
    saveCall(){
      if(this.newCall){
        this.$emit("save-call", this.newCall);
      }
    },
    prev() {
      this.activeDate = moment(
        this.activeDate.subtract(1, this.activeView + "s")
      );
    },
    next() {
      this.activeDate = moment(this.activeDate.add(1, this.activeView + "s"));
    },
    switchView(view) {
      this.activeView = view;
    },
    getRepClientsData(){
      let text = '';
      if(this.replaceClientsArr){
        this.replaceClientsArr.map(id=>{
          text = `${text} ${id},`
        })
       text =  'Save And Reschedule To Clients ' + text
      }
      return text;
    },
  },
  filters: {
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    }
  },
  watch: {
    initialDate() {
      this.activeDate = moment(this.initialDate);
    },
    initialView() {
      this.activeView = this.initialView;
    },
    activeDate() {
      this.$emit(this.activeView + "-changed", this.activeDate.toDate());
    },
    activeView() {
      this.$emit("view-changed", this.activeView);
    }
  },
  computed: {
    ...mapState("clients", ["openCaComponent", "dictionaries"]),
    newEvents() {
      return this.events.map(e => {
        return new Event(e).bindGetter("displayText", this.eventDisplay);
      });
    },
    isPrevAllowed() {
      if (this.minDate) {
        const prevRef = moment(this.activeDate).subtract(
          1,
          this.activeView + "s"
        );
        return this.minDate.isSameOrBefore(prevRef, this.activeView);
      }
      return true;
    },
    isNextAllowed() {
      if (this.maxDate) {
        const afterRef = moment(this.activeDate).add(1, this.activeView + "s");
        return this.maxDate.isSameOrAfter(afterRef, this.activeView);
      }
      return true;
    },
    activeViewProps() {
      let props = {
        activeDate: this.activeDate,
        minDate: this.minDate,
        maxDate: this.maxDate,
        use12: this.use12,
        events: this.newEvents.filter(event => {
          return event.date.isSame(this.activeDate, this.activeView);
        }),
        shift:this.shift,
        newCall: this.newCall

      };

      if (this.activeView === "week" || this.activeView === "day") {
        props.allDayLabel = this.labels.all_day;
        props.timeRange = this.timeRange;
        props.showTimeMarker = this.showTimeMarker;
      }
      return props;
    },
    calendarTitle() {
      if (this.activeDate === null) return "";

      if (this.activeView === "month") {
        return this.activeDate.format("MMMM YYYY");
      }

      if (this.activeView === "week") {
        const weekStart = moment(this.activeDate).day(0);
        const weekEnd = moment(this.activeDate).day(6);
        return weekStart.format("MMM D") + " - " + weekEnd.format("MMM D");
      }

      if (this.activeView === "day") {
        return this.activeDate.format("dddd MMM D");
      }
      return true;
    }
  }
};
</script>

<style scoped>
  .v-cal-button.is-primary {
    float: right;
    border-color: #44a2d2;
    background-color: #44a2d2;
    color: #fff;
    margin-top: 9px;
  }
  .btn-alert{
    border-color: #d25a20!important;
    background-color: #a0380d!important;
  }
</style>
